import { isPlainObject } from 'lodash';

export async function fetchPropertiesByInsightsId(insightsIds) {
  const params = new URLSearchParams();
  insightsIds.forEach(id => params.append('q[insights_property_external_id_in][]', id));

  const request = await get('/properties', params);
  const properties =  await request.json();
  return properties;
}

export function bookmarkProperty(insightsId, bookmarked) {
  return post(
    '/favorites/make_favorite',
    {
      associated_model_id: insightsId,
      associated_model_type: 'Insights::Property',
      bookmarked: bookmarked ? '1' : '0'
    }
  );
}

export function getPnProperty(insightsId) {
  return get(`/research/${insightsId}/info`, undefined).then((response) => {
    if (!response.ok) {
      throw new Error(response.status + ' Failed Fetch ');
    }

    return response.json();
  });
}

export function fetchTaggingsForInsightsProperty(insightsPropertyId) {
  return get(`/research/${insightsPropertyId}/tags`).then(response => response.json());
}

export function fetchTags(searchString) {
  return get(
    '/tags',
    { 'q[name_cont]': searchString }
  ).then(response => response.json());
}

export function tagProperty(tagId, insightsId) {
  return post(
    '/taggings',
    {
      tagging: {
        tag_id: tagId,
        taggable_type: 'Insights::Property',
        taggable_id: insightsId
      }
    }
  ).then(response => response.json());
}

export function createTag(name) {
  return post('/tags', { tag: { name } }).then(response => response.json());
}

export function deleteTagging(taggingId) {
  return deleteRequest(`/taggings/${taggingId}`);
}

export async function fetchCallLists(params = {}) {
  const request = await get('/call_lists', params);
  const callLists =  await request.json();
  return callLists;
}

export async function addToList(id, items = []) {
  return post(
    `/call_lists/${id}/add_objects_to_list`,
    { call_list: { call_list_items_attributes: items } }
  );
}

export async function createList(data) {
  return post(`/call_lists`, { call_list: data });
}

export function fetchInsightsPropertyNotes(insightsPropertyId) {
  return get(`/research/${insightsPropertyId}/notes`)
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.status + ' Failed Fetch ');
      }

      return response.json();
    });
}

export function createNote(data) {
  return post('/notes', { note: data }).then(response => response.json());
}

export function updateNote(id, body) {
  return patch(`/notes/${id}`, { note: { body: body } }).then(response => response.json());
}

export function deleteNote(noteId) {
  return deleteRequest(`/notes/${noteId}`).then(() => noteId);
}

export async function bookmarkedProperties(bookmarked) {
  const request = await get(`/properties`, { 'q[bookmarked]': bookmarked });
  const properties =  await request.json();

  return properties;
}

export function fetchContacts(searchString) {
  return get(
    '/contacts/list',
    { 'q[search_text_cont]': searchString }
  )
    .then(response => response.json())
    .then(data => data.contacts);
}

export function fetchCompanies(searchString) {
  return get(
    '/companies/list',
    { 'q[search_text_cont]': searchString }
  )
    .then(response => response.json())
    .then(data => data.companies);
}

export function addContactToProperty(contactId, contactType, insightsPropertyId) {
  let url;

  if (contactType === 'Contact') {
    url = `/contacts/${contactId}/add_property_ownership`;
  } else if (contactType === 'Company') {
    url = `/companies/${contactId}/add_property_ownership`;
  } else {
    return;
  }

  return post(url, { owned_id: insightsPropertyId, owned_type: 'Insights::Property' });
}

function clarityUrl(path) {
  if (!window.CLARITY_URL) throw new Error('CLARITY_URL is not defined');

  return `${window.CLARITY_URL}${path}`;
}

function patch(path, body) {
  return makeRequest('PATCH', path, body);
}

function post(path, body) {
  return makeRequest('POST', path, body);
}

function get(path, params) {
  const pnParams = isPlainObject(params) ? new URLSearchParams(params) : params;
  return makeRequest('GET', `${path}?${pnParams}`);
}

function deleteRequest(path) {
  return makeRequest('DELETE', path);
}

function makeRequest(method, path, body) {
  const options = {
    method,
    mode: 'cors',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };

  if (body) options.body = JSON.stringify(body);

  return fetch(clarityUrl(path), options);
}
